import React, { useEffect, useState } from "react";
import { Content } from "./styles";
import { Load } from "../Load";
import { Empty } from "../Empty";
import { IQueue } from "../../pages/Queue";
import moment from "moment";
import { api } from "../../services/api";
import { message } from "antd";
import { Pagination } from "../Pagination";
import { socket } from "../../services/socket";

interface Props {
  total: number
}
export function QueueDelayeddTable({
  total = 0
}: Props) {
  const [loading, setLoading] = useState(false);
  const [queues, setQueues] = useState<IQueue[]>([]);
  const [page, setPage] = useState(0);
  const [limitPerPage, setLimitPerPage] = useState(10);

  function fetchData() {
    setLoading(true)
    api.post('/queue', {
      status: ['delayed'],
      start: page * limitPerPage,
      end: (page * limitPerPage) + limitPerPage
    }).then((response) => {
      setQueues(response.data)
    }).catch((err) => {
      message.error(err.response.data.message);
    }).finally(() => setLoading(false))
  }
  function handleNextPage() {
    if (page + 1 >= Math.ceil(total / limitPerPage)) {
      return;
    }
    setPage((prevState) => prevState + 1);
  }
  function handlePreviusPage() {
    if (page - 1 < 0) {
      return;
    }
    setPage((prevState) => prevState - 1);
  }
  function handleLastPage() {
    setPage(Math.ceil(total / limitPerPage) - 1);
  }
  function handleFirstPage() {
    setPage(0);
  }
  function handleChangeLimitPerPage(value: number) {
    if (total > 0) {
      if (page > Math.ceil(total / value)) {
        setPage(Math.ceil(total / value) - 1);
      }
    }
    setLimitPerPage(value);
  }
  useEffect(fetchData, [limitPerPage, page]);
  useEffect(() => {
    socket.on("queue-resume", () => {
      fetchData();
    });
    socket.on("queue-paused", () => {
      fetchData();
    });
    socket.on("queue-canceled", () => {
      fetchData();
    });
    socket.on("delayed", () => {
      fetchData();
    });
  }, [])
  return (
    <Content>
      <table>
        <thead>
          <tr>
            <th rowSpan={1} colSpan={1}>
              Cliente
            </th>
            <th rowSpan={1} colSpan={1}>
              Número
            </th>
            <th rowSpan={1} colSpan={2}>
              Mensagem
            </th>
            <th rowSpan={1} colSpan={1}>
              Data
            </th>
          </tr>{" "}
        </thead>
        <tbody>
          {
            loading
              ? (
                <tr>
                  <td rowSpan={1} colSpan={6}>
                    <div className="loading">
                      <Load />
                    </div>
                  </td>
                </tr>
              )
              : queues.length ? (
                queues.map((queue) => (
                  <>
                    <tr key={queue.id}>
                      <td rowSpan={1} colSpan={1}>
                        {queue.data.clientId.split('-')[0].toUpperCase()}
                      </td>
                      <td rowSpan={1} colSpan={1}>
                        {queue.data.number}
                      </td>
                      <td rowSpan={1} colSpan={2}>
                        {queue.data.message}
                      </td>
                      <td rowSpan={1} colSpan={1}>
                        {moment(queue.timestamp).calendar()}
                      </td>
                    </tr>
                  </>
                ))
              ) : (
                <tr>
                  <td rowSpan={1} colSpan={6}>
                    <Empty />
                  </td>
                </tr>
              )
          }
        </tbody>
      </table>
      <Pagination
        totalItems={total}
        first={handleFirstPage}
        last={handleLastPage}
        limitChange={handleChangeLimitPerPage}
        next={handleNextPage}
        prev={handlePreviusPage}
        currentPage={page}
      />
    </Content>
  );
}
